import React from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";

/**
 * Floating button which can start the tour
 * */

const TakeTourFloatingButton = ({ setIsShownFirstTime, tourName }) => {
  const { getTextByKey, getDirection } = useContent();

  const handleClick = () => {
    setIsShownFirstTime(true);
  };

  return (
    <>
      {tourName === "create-form" ? (
        <div className="create-form-take-tour" onClick={handleClick}>
          <Tooltip
            id="takeTourFloatingButton"
            tooltipTextKey={getTextByKey("tour_help")}
          >
            <div className="floating-button-wrapper">
              <span className="quest-icon">?</span>
              <span className="text-tour-button">
                {getTextByKey("create-form-tour-button")}
              </span>
            </div>
          </Tooltip>
        </div>
      ) : (
        <div
          className={`take-tour-floating-button floating-button-${getDirection()}`}
          onClick={handleClick}
        >
          <Tooltip
            id="takeTourFloatingButton"
            tooltipTextKey={getTextByKey("tour_help")}
          >
            <div className="floating-button-wrapper">
              <p>{getTextByKey("welcome_tour_start")}</p>
            </div>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default TakeTourFloatingButton;
